import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { getOneStoreQuotation } from '../../../../../Store/Store/StoreQuotation/getOneStoreQuotation';
import { getAdminItem } from '../../../../../Store/Store/Item/AdminItem';
import moment from 'moment';
import ReactQuill from 'react-quill';
import { quillFormats, quillModules } from '../../../../../helper/quotation';

const CreateQuotationModal = ({ initial, onSave, onClose, id }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    voucher_date: "",
    voucher_no: "",
    estimate_details: {
      // vendor_code: "",
      supply_place: "", reference_no: "", enquiry_no: ""
    },
    items: [],
    terms_and_condition: "",
    internal_note: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(getAdminItem({ is_main: true }));
    if (id) {
      dispatch(getOneStoreQuotation(id));
    }
  }, [dispatch, id]);

  const quotataionData = useSelector((state) => state?.getOneStoreQuotation?.user?.data);
  const itemData = useSelector((state) => state?.getAdminItem?.user?.data);

  useEffect(() => {
    if (quotataionData) {
      setForm({
        ...quotataionData,
        voucher_date: moment(quotataionData.voucher_date).format('YYYY-MM-DD') || "",
        estimate_details: {
          // vendor_code: quotataionData.estimate_details?.vendor_code || "",
          supply_place: quotataionData.estimate_details?.supply_place || "",
          reference_no: quotataionData.estimate_details?.reference_no || "",
          enquiry_no: quotataionData.estimate_details?.enquiry_no || ""
        },
        items: quotataionData.items || [],
        terms_and_condition: quotataionData.terms_and_condition || "",
        internal_note: quotataionData.internal_note || ""
      });
    } else if (initial) {
      setForm({
        ...initial,
        voucher_date: moment(initial.voucher_date).format('YYYY-MM-DD') || "",
        estimate_details: {
          // vendor_code: initial.estimate_details?.vendor_code || "",
          supply_place: initial.estimate_details?.supply_place || "",
          reference_no: initial.estimate_details?.reference_no || "",
          enquiry_no: initial.estimate_details?.enquiry_no || ""
        },
        items: initial.items || [],
        terms_and_condition: initial.terms_and_condition || "",
        internal_note: initial.internal_note || ""
      });
    }
  }, [quotataionData, initial]);

  const validate = () => {
    let newErrors = {};
    if (!form.voucher_date) newErrors.voucher_date = "Voucher Date is required";
    // if (!form.estimate_details.vendor_code) newErrors.vendor_code = "Vendor Code is required";

    if (form.items.length === 0) {
      newErrors.items = "Please add at least one item";
    } else {
      form.items.forEach((item, idx) => {
        if (!item.item_id) newErrors[`item_${idx}_item_id`] = "Item selection is required";
        if (!item.quantity) newErrors[`item_${idx}_quantity`] = "Quantity is required";
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const setFormField = (field, val) => {
    setForm(f => ({ ...f, [field]: val }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
  };

  const setDetailField = (field, val) => {
    setForm(f => ({ ...f, estimate_details: { ...f.estimate_details, [field]: val } }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
  };

  const addItem = () => {
    setFormField("items", [...form.items, { item_id: "", item_name: "", description: "", size: "", unit_name: "", hsn_no: "", quantity: "" }]);
    if (errors.items) setErrors(prev => ({ ...prev, items: null }));
  };

  const removeItem = (idx) => {
    setFormField("items", form.items.filter((_, i) => i !== idx));
  };

  const updateItem = (idx, field, val) => {
    setFormField("items", form.items.map((item, i) => i === idx ? { ...item, [field]: val } : item));
    if (errors[`item_${idx}_${field}`]) setErrors(prev => ({ ...prev, [`item_${idx}_${field}`]: null }));
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSave(form);
  };

  return (
    <Modal show={true} onHide={onClose} size="xl" centered backdrop="static">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>{initial ? "Edit Quotation" : "New Quotation Inquiry"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        <Form>
          <Row className="mb-3">
            <Col md={3} className='mb-3'>
              <Form.Group>
                <Form.Label className="small fw-bold">Voucher Date <span className='text-danger'>*</span></Form.Label>
                <Form.Control size="sm" type="date" value={form.voucher_date} onChange={e => setFormField("voucher_date", e.target.value)} isInvalid={!!errors.voucher_date} />
                {errors.voucher_date && <Form.Control.Feedback type="invalid">{errors.voucher_date}</Form.Control.Feedback>}
              </Form.Group>
            </Col>
            {/* <Col md={3} className='mb-3'>
              <Form.Group>
                <Form.Label className="small fw-bold">Vendor Code <span className='text-danger'>*</span></Form.Label>
                <Form.Control size="sm" type="text" value={form.estimate_details.vendor_code} onChange={e => setDetailField("vendor_code", e.target.value)} placeholder="Enter Vendor Code" isInvalid={!!errors.vendor_code} />
                {errors.vendor_code && <Form.Control.Feedback type="invalid">{errors.vendor_code}</Form.Control.Feedback>}
              </Form.Group>
            </Col> */}
            <Col md={3} className='mb-3'>
              <Form.Group>
                <Form.Label className="small fw-bold">Supply Place</Form.Label>
                <Form.Control size="sm" value={form.estimate_details.supply_place} onChange={e => setDetailField("supply_place", e.target.value)} placeholder='Enter Supply Place' />
              </Form.Group>
            </Col>
            <Col md={3} className='mb-3'>
              <Form.Group>
                <Form.Label className="small fw-bold">Reference No</Form.Label>
                <Form.Control size="sm" value={form.estimate_details.reference_no} onChange={e => setDetailField("reference_no", e.target.value)} placeholder='Enter Reference No' />
              </Form.Group>
            </Col>
            <Col md={3} className='mb-3'>
              <Form.Group>
                <Form.Label className="small fw-bold">Enquiry No</Form.Label>
                <Form.Control size="sm" value={form.estimate_details?.enquiry_no} onChange={e => setDetailField("enquiry_no", e.target.value)} placeholder='Enter Enquiry No' />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-3'>
            <Col md={12}>
              <Form.Group>
                <Form.Label className="small fw-bold">Internal Note</Form.Label>
                <Form.Control as="textarea" rows={3} value={form.internal_note} onChange={e => setFormField("internal_note", e.target.value)} />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 fw-bold" style={{ color: '#444648ff' }}>Items / Requirements</h5>
            <Button
              variant="primary"
              size="sm"
              onClick={addItem}
              className="fw-bold px-3"
              disabled={form.items.some(it => !it.item_id || !it.quantity)}
            >
              + Add Item
            </Button>
          </div>

          {form.items.length === 0 && (
            <div className="text-center py-4 text-muted rounded mb-4" style={{ border: '1px dashed #ced4da', backgroundColor: '#f8f9fa', fontSize: '13px' }}>
              No items added yet. Click "Add Item" to start.
            </div>
          )}
          {errors.items && <div className="text-danger small mb-3">{errors.items}</div>}

          {form.items.map((item, idx) => (
            <div key={idx} className="p-3 mb-3 rounded border shadow-sm" style={{ backgroundColor: '#ffffff' }}>
              <div className="d-flex justify-content-between align-items-center mb-3 pb-2">
                <span className="fw-bold" style={{ fontSize: '13px', color: '#f97316' }}>Item #{idx + 1}</span>
                <Button variant="danger" size="sm" onClick={() => removeItem(idx)} className="px-3 py-1" style={{ fontSize: '12px', borderRadius: '4px' }}>Remove</Button>
              </div>
              <Row className="g-3">
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Item Name <span className="text-danger">*</span></Form.Label>
                    <Dropdown
                      value={item.item_id}
                      onChange={(e) => {
                        const selectedItem = itemData?.find(it => it._id === e.value);
                        setFormField(
                          "items",
                          form.items.map((it, i) =>
                            i === idx
                              ? {
                                ...it,
                                item_id: selectedItem?._id || "",
                                item_name: selectedItem?.name || "",
                                hsn_no: selectedItem?.hsn_code || "",
                                unit_name: selectedItem?.unit?.name || "PCS"
                              }
                              : it
                          )
                        );
                      }}
                      options={itemData?.map(opt => ({
                        label: opt.name,
                        value: opt._id
                      })) || []}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Item"
                      filter
                      className={`w-100 ${errors[`item_${idx}_item_id`] ? 'p-invalid' : ''}`}
                    />
                    {errors[`item_${idx}_item_id`] && <div className="text-danger small mt-1" style={{ fontSize: '11px' }}>{errors[`item_${idx}_item_id`]}</div>}
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Size</Form.Label>
                    <Form.Control size="sm" value={item.size} onChange={e => updateItem(idx, "size", e.target.value)} placeholder="e.g. 16mm, AG-4" />
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>HSN Code</Form.Label>
                    <Form.Control size="sm" value={item.hsn_no} onChange={e => updateItem(idx, "hsn_no", e.target.value)} placeholder="84641000" />
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Unit</Form.Label>
                    <Form.Control size="sm" value={item.unit_name} readOnly placeholder="Unit" />
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Quantity <span className='text-danger'>*</span></Form.Label>
                    <Form.Control size="sm" type="number" value={item.quantity} onChange={e => updateItem(idx, "quantity", e.target.value)} placeholder="0" isInvalid={!!errors[`item_${idx}_quantity`]} />
                    {errors[`item_${idx}_quantity`] && <Form.Control.Feedback type="invalid">{errors[`item_${idx}_quantity`]}</Form.Control.Feedback>}
                  </Form.Group>
                </Col>
                <Col md={4} sm={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-muted mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Description</Form.Label>
                    <Form.Control size="sm" value={item.description} onChange={e => updateItem(idx, "description", e.target.value)} placeholder="Brief description" />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}

          {/* terms and condition section  */}
          <div className="row">
            <div className="col-12">
              <div
                className="card shadow-sm h-100"
                style={{ border: "1px solid #e0e0e0" }}
              >
                <div
                  className="card-header"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid var(--primary-clr)",
                    color: "var(--primary-clr)",
                  }}
                >
                  <h6
                    className="mb-0 fw-semibold"
                    style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                  >
                    <i
                      className="fa fa-file-text me-2"
                      style={{ color: "var(--primary-clr)" }}
                    ></i>
                    Terms and Conditions
                  </h6>
                </div>

                <div
                  className="card-body p-0 terms-editor-wrapper"
                  style={{ height: "300px", overflow: "hidden" }}
                >
                  <ReactQuill
                    theme="snow"
                    value={form.terms_and_condition}
                    onChange={e => setFormField("terms_and_condition", e)}
                    modules={quillModules}
                    formats={quillFormats}
                    style={{ height: "280px" }}
                  />
                </div>
              </div>
            </div>
          </div>


        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" className='rounded-2 py-1 px-3' onClick={onClose}>Cancel</Button>
        <Button variant="primary" size="sm" className='rounded-2 py-1 px-3' onClick={handleSubmit}>
          {initial ? "Save Changes" : "Create Quotation"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateQuotationModal;
